  import React, { useEffect, useState } from "react";
  import { useSelector } from "react-redux";
  import moment from "moment";
  import { Modal } from "react-bootstrap";
  import { NSE_filter_volume } from "../utils/constants";
  import { analyzeMarket, calculateMomentum } from "../utils/utilsFunctions";
  import StockAction from "./stockAction";
  import { getDeliveryPercentList } from "../action/api-services";
  import imgLoaderURL from "../assets/images/loader.gif";

  const DeliveryGraph = ({ symbol, todayLTP, date }) => {
    // localStorage.setItem('monthlyStatus', false);

    
    
    const [getDeliverData, setDeliverData] = useState([]);
    const [getStructure, setStructure] = useState([]);
    const [show, setShow] = useState(false);
    const [max, setMax] = useState(false);
    const [min, setMin] = useState(false);
    const [getAvgVolume, setAvgVolume] = useState(0);
    const [getAvgVolumePer, setAvgVolumePerc] = useState(0);    
    const [getAvgNoTrde, setAvgNoTrade] = useState(0);
    const [getTrueAverageCount, setTrueAverageCount] = useState(false);
    const [lastDeliveryDate, setLastDeliveryDate] = useState();
    const [trend, setTrend] = useState("");
    const [dataRange, setdataRange] = useState([]);
    const [xTicks, setXTicks] = useState([]);
    const [deliveryData , setDeliveryData] = useState([]);
    const [deliveryDataAll , setDeliveryDataAll] = useState([]);
    const [symbolDeliveryData , setSymbolDeliveryData] = useState([]);
    const [getMomentumData , setMomentumData] = useState([]);
    const [maxClosePrice, setMaxClosePrice] = useState(0);
    const [minClosePrice, setMinClosePrice] = useState(0);
    const [avgCount_No, setavgCount_No] = useState(0);
    const [imgLoader, setImgLoader] = useState(false);
    
    const minPct = 40;
    const maxPct = 100;
    



    const deliveryDataList = useSelector((state) => state.deliveryData.value);
    const userToken = useSelector((state) => state.userToken.value);
    
    useEffect(() => {
        let list = [];

        // normalize data
        if (Array.isArray(deliveryDataList)) {
          list = deliveryDataList;
        } else if (deliveryDataList && typeof deliveryDataList === 'object') {
          list = Object.values(deliveryDataList);
        }

        if (list.length > 0) {
          const item = list.find((item) => item.symbol === symbol);

          if (item) {
            setDeliveryData(item?.stock_data || null);
            setDeliveryDataAll(item);
          }
        }

    }, [deliveryDataList, symbol]);





    // console.log("deliveryData", deliveryData)
    let prevAvg = 0;
    const handlerDaysGraph = (e, symbol) => {
      e.preventDefault();
      setImgLoader(true);

      getDeliveryPercentList('', 'ticker', '', symbol, 'EQ', '', userToken).then(function (response) {
              // console.log(response.data.date, response.data.data, symbol)
             
              let stockData = Object.values(response.data.data)[0];
              let data = stockData.stock_data;
              setLastDeliveryDate(response.data.date);
              setSymbolDeliveryData(data);


            const threshold = 200000;
            let trueAverageCount = 0;
              
            setTrend(analyzeMarket(data));



            const volumes = data.map((d) => parseInt(d.ttl_trd_qty, 10));
            const no_of_trades = data.map((d) => parseInt(d.no_of_trades, 10));
            volumes.forEach((v, i) => {
              if (v >= threshold) {
                trueAverageCount = trueAverageCount + 1;
              }
            });


            const avgVolumes = Math.round(
                volumes.reduce((sum, volume) => sum + volume, 0) / volumes.length
            );

            const count_no_more_AVGVolume = volumes.reduce(
              (count, v) => count + (Number(v) > Number(avgVolumes) ? 1 : 0),
              0
            );


            setavgCount_No(count_no_more_AVGVolume);


            const minVolume = Math.min(...volumes);
            const maxVolume = Math.max(...volumes);
            const avgVolumratio = (avgVolumes - minVolume) / (maxVolume - minVolume);
            const avg_volumePercent = Math.round(minPct + avgVolumratio * (maxPct - minPct));


            const avg_no_of_trades = no_of_trades.reduce((sum, trade) => sum + trade, 0) / no_of_trades.length;

            const sortedUnique = [...new Set(volumes)].sort((a, b) => b - a);
            const rankMap = new Map();
            sortedUnique.forEach((v, i) => {
              const rankNum = i + 1;
              const rankStr = String(rankNum).padStart(2, "0");
              rankMap.set(v, rankStr);
            });

            
            const newData = data.map((item) => ({
              ...item,
              rank: rankMap.get(parseInt(item.ttl_trd_qty, 10)),
            }));

            setDeliverData(newData);
            


            const { min, max } = (data.slice(0, data.length - 1) || []).reduce(
              (acc, item) => {
                const raw = item?.ttl_trd_qty;
                if (raw == null) return acc;
                const v = Number(String(raw).replace(/,/g, "").trim());
                if (!Number.isFinite(v)) return acc;

                if (acc.min === null || v < acc.min) acc.min = v;
                if (acc.max === null || v > acc.max) acc.max = v;
                return acc;
              },
              { min: null, max: null }
            );

            setMax(max);
            setMin(min);
            setAvgVolume(avgVolumes);
            setAvgVolumePerc(avg_volumePercent);
            setAvgNoTrade(avg_no_of_trades)
            setTrueAverageCount(trueAverageCount >= volumes.length - 3);
            setShow(true);
            setImgLoader(false);

                    })
        .catch(function (err) {
          console.log("Error", err);
      });

    };

    const handleClose = () => {
      setShow(false);
      setDeliverData([]);
    };

    // For today data
    const isNewDay = todayLTP && todayLTP?.DATETIME !== "#N/A" && !moment(todayLTP?.DATETIME).isSame(lastDeliveryDate, "day");
    const todayCurrentTime = todayLTP?.DATETIME;
    const todayChnPer = todayLTP?.CHANGEPER;
    const todayVolume = todayLTP?.VOLUME;
    const todayMARKETCAP = todayLTP?.MARKETCAP;
    const todayRatio = (todayVolume - min) / (max - min);
    const todayPercent = Math.round(minPct + todayRatio * (maxPct - minPct));
    const todayPrevVol = parseInt(deliveryData[0]?.ttl_trd_qty);
    const todayPrevDiff = (((todayVolume - todayPrevVol) * 100) / todayPrevVol).toFixed("2");

    let todayTurnover = todayVolume * todayLTP?.LTP;
    let todayTurnover_Cap = Math.round(todayTurnover / 10000000);
    let todayTurnover_per = parseFloat(
      ((todayTurnover / todayMARKETCAP) * 100).toFixed(2)
    );

    let isMaxinWeek = false;
    let isMaxAvginWeek = 0
    // const findIndex = deliveryData.findIndex((d) => d.delivery_date === date);
    const findIndex = Math.max(0, symbolDeliveryData.findIndex(d => d.delivery_date === moment(date).format("YYYY-MM-DD")));


  useEffect(() =>{
      // setStructure(JSON.parse(getDeliverData[0]?.structure_json || '[]'));
      setStructure(deliveryDataAll?.structure_json || []);
      // setStructure(getDeliverData[0]?.structure_json);
  }, [getDeliverData])


    
  useEffect(() => {
      if(trend){
        const pointsData = [...symbolDeliveryData].slice(0, symbolDeliveryData.length - 1)
          .sort((a, b) => new Date(a.delivery_date) - new Date(b.delivery_date))
          .map((d, i, arr) => {
            // console.log(d);
            const prev = arr[i - 1];
            return ({
            time: new Date(d.delivery_date).getTime(), // ✅ numeric
            date: d.delivery_date,
            price: Number(d.close_price),
            SMA20: Number(d.SMA20) !== 0 ? Number(d.SMA20) : Number(prev?.SMA20 || 0),
            EMA20: Number(d.EMA20) !== 0 ? Number(d.EMA20) : Number(prev?.EMA20 || 0)
          })
        
          });


          const momnetumsData = [...symbolDeliveryData].map(d => ({
            close_price: d.close_price,
            ttl_trd_qty: d.ttl_trd_qty,
            delivery_date: d.delivery_date,
          }));


         
          if (isNewDay) {
            const last = symbolDeliveryData[0]; // assuming latest data at index 0

            pointsData.push({
              time: new Date(todayLTP.DATETIME).getTime(),
              // date: new Date(todayLTP.DATETIME).toISOString().slice(0, 10),
              price: Number(todayLTP.LTP),
              SMA20: Number(last.SMA20),
              EMA20: Number(last.EMA20)
            });

            momnetumsData.unshift({
                close_price: todayLTP.LTP,
                ttl_trd_qty: todayLTP.VOLUME,
                delivery_date: new Date(todayLTP.DATETIME).toISOString().slice(0, 10)
            });


          }

          const getMometum = calculateMomentum(momnetumsData);
          setMomentumData(getMometum);
          

          const width = 600;
          const height = 425;
          const padding = 18;

          const times = pointsData.map(p => p.time);
          const prices = pointsData.map(p => p.price);
          const SMA20es = pointsData.map(p => p.SMA20);
          const EMA20es = pointsData.map(p => p.EMA20);

          const minTime = Math.min(...times);
          const maxTime = Math.max(...times);
          
          const allValues = [
            ...prices,
            ...SMA20es,
            ...EMA20es
          ].filter(v => Number.isFinite(v));

          const minValue = Math.min(...allValues);
          const maxValue = Math.max(...allValues);

          // const averagePrice = prices.reduce((sum, price) => sum + price, 0) / prices.length;
          setMinClosePrice(minValue);
          setMaxClosePrice(maxValue);
          // setAvgClosePrice(averagePrice);


          const stepX = width / (pointsData.length - 1);

          const priceArr = pointsData.map((p, i) => {
            const x = padding + i * stepX;
            const y = padding + height - ((p.price - minValue) / (maxValue - minValue || 1)) * (height);
            return `${x},${y}`;
          }).join(" ");


          const SMA20Arr = pointsData.map((p, i) => {
            const x = padding + i * stepX;
            const y = padding + height - ((p.SMA20 - minValue) / (maxValue - minValue || 1)) * (height);
            return `${x},${y}`;
          }).join(" "); 
          
          const EMA20Arr = pointsData.map((p, i) => {
            const x = padding + i * stepX;
            const y = padding + height - ((p.EMA20 - minValue) / (maxValue - minValue || 1)) * (height);
            return `${x},${y}`;
          }).join(" "); 
        

          // setdataRange(points);
          setdataRange({price:priceArr, SMA20:SMA20Arr, EMA20: EMA20Arr});


  const ticks = pointsData.map((p, i) => {
    const x = padding + (i / (pointsData.length)) *  (width + 30);

    return {
      x,
      label: new Date(p.time).toLocaleDateString("en-IN", {
        day: "2-digit",
        // month: "short"
      })
    };
  });

  setXTicks(ticks);


          
      }
    }, [trend])

    let monthPer = (todayLTP?.LTP - getDeliverData[getDeliverData?.length - 2]?.close_price) * 100 / getDeliverData[getDeliverData?.length - 2]?.close_price;
    let daysPer = (todayLTP?.LTP - getDeliverData[findIndex]?.close_price) * 100 / getDeliverData[findIndex]?.close_price;


    return (
      <React.Fragment>
        <button
          className="deliveryGraphBtn"
          onClick={(e) => handlerDaysGraph(e, symbol)}
        >
          {imgLoader === true? <img src={imgLoaderURL} alt="loader" className="loader" /> : ''}
          <ul className="deliveryGraph">
            {deliveryData
              ?.slice(0, 5)
              .reverse()
              .map((obj, ind) => {
                let golden = false;
                let delp =
                  obj.delivery_per < 90 ? Math.round(obj.delivery_per / 10) : 9;

                const volumes = deliveryData.map((d) =>
                  parseInt(d.ttl_trd_qty, 10)
                );
                const avgVolumes = Math.round(
                  volumes
                    .slice(0, deliveryData.length - 1)
                    .reduce((sum, val) => sum + val, 0) /
                    (volumes.length - 1)
                );
                const volume = parseInt(obj.ttl_trd_qty);

                const { min, max } = (
                  deliveryData.slice(0, deliveryData.length - 1) || []
                ).reduce(
                  (acc, item) => {
                    const raw = item?.ttl_trd_qty;
                    if (raw == null) return acc;
                    const v = Number(String(raw).replace(/,/g, "").trim());
                    if (!Number.isFinite(v)) return acc;

                    if (acc.min === null || v < acc.min) acc.min = v;
                    if (acc.max === null || v > acc.max) acc.max = v;
                    return acc;
                  },
                  { min: null, max: null }
                );

                if (volume >= max) {
                  isMaxinWeek = true;
                }

                if (volume > avgVolumes && avgVolumes > NSE_filter_volume) {
                  isMaxAvginWeek = isMaxAvginWeek + 1;
                }

                if (ind < 4) {
                  prevAvg = parseFloat(prevAvg) + parseFloat(obj.delivery_per);
                }

                if (
                  ind === 4 &&
                  // && isMaxinWeek === true
                  isMaxAvginWeek > 2 &&
                  // && parseFloat(deliveryData[0].close_price) > parseFloat(deliveryData[1].close_price)
                  // && parseFloat(deliveryData[0].delivery_per) > parseFloat(deliveryData[1].delivery_per)
                  // && parseFloat(deliveryData[1].delivery_per) > parseFloat(deliveryData[2].delivery_per)

                  // && parseFloat(deliveryData[0].ttl_trd_qty) > parseFloat(deliveryData[1].ttl_trd_qty)

                  parseFloat(obj.close_price) > parseFloat(obj.prev_close) &&
                  parseFloat(obj.prev_close) >
                  parseFloat(deliveryData[1].prev_close) &&
                  parseFloat(obj.delivery_per) > prevAvg / 4
                ) {
                  // if(ind === 4  && (obj.close_price > obj.prev_close) && (parseFloat(obj.prev_close) > parseFloat(deliveryData[1].prev_close)) && (parseFloat(obj.delivery_per) > prevAvg/4)){
                  golden = true;
                }
                return (
                  <li key={`gra_${ind}`}>
                    <span
                      title={`${obj.close_price}(${obj.chn_per}%) | ${
                        obj.delivery_per
                      }% | ${moment(obj.delivery_date).format("DD/MM/YYYY")}`}
                      className={golden === true ? "golden" : ""}
                      style={{
                        height: `${4 + delp}px`,
                        backgroundColor:
                          obj.chn_per > 0
                            ? `rgba(100, 150, 100, 1)`
                            : `rgba(200, 80, 80, 1)`,
                      }}
                    ></span>
                  </li>
                );
              })}
          </ul>
        </button>

        <Modal
          show={show}
          onHide={handleClose}
          // fullscreen = {true}
          dialogClassName="watchlist-details deiveryGraph"
          centered
        >
          <Modal.Header
            closeButton
            onClick={(e) => e.stopPropagation()}
          ></Modal.Header>
          <Modal.Body>
            <div className="till_monthper">Month Per: <span style={{color:monthPer>0? "#24bf19":"#F00" }}>{monthPer?.toFixed(2)}</span>% | <span style={{color:daysPer>0? "#24bf19":"#F00" }}>{daysPer?.toFixed(2)}</span>%</div>
            <div className="pt-4 pb-5">
              <div className="colTitle">
                {symbol} [<span title="Today MarketCap">{Math.round(todayMARKETCAP/10000000)}</span>]| Max:- <strong title="Max Volume in 22 Days">{max?.toLocaleString("en-IN")}</strong> |
                AVG:-{" "}
                <strong
                  title="Average Volume of 22 trading days"
                  style={{
                    color:
                      getAvgVolume > 200000 && getTrueAverageCount === true
                        ? "#59cd52"
                        : "#f00",
                  }}
                >
                  {getAvgVolume?.toLocaleString("en-IN")}
                </strong>{" "} 
                <span title="Count of > Average Volume & %">[{avgCount_No}]  {Math.round((avgCount_No / getDeliverData.length) * 100)}% </span>
                |{" "}
                <strong
                  title="Slope° | Confidence"
                  style={{
                    color:
                      getStructure?.structure === "EARLY_DOWNTREND" || getStructure?.structure === "UPTREND" || getStructure?.structure === "BULLISH_CHOCH"
                        ? "#59cd52"
                        : getStructure?.structure === "DOWNTREND" || getStructure?.structure === "BEARISH_CHOCH"
                        ? "#f00"
                        : "#ffc800",
                  }}
                >
                  {getStructure?.structure} [{getStructure?.slope}°] {getStructure?.confidence}
           
                  
                </strong>
                <div className="modalStockAcion">
                  <StockAction
                    symbol={symbol}
                    delivery={false}
                    // currentPrice ={todayLTP?.LTP?.toFixed(2)}
                    // deliveryPer={getDeliverData[0].delivery_per}
                    // hotStar={obj.details?.hotStar} myFev={obj.details?.myFev}
                    // eventName = {trends===''?'Delivery':trends} rowId=""
                  />
                </div>
                <span className="chnper">Chn | Chn%</span>
                <span className="score">Score%</span>
                <span className="atr">ATR%</span>
                <span className="trunoverChnper">Turnover[%]</span>
              </div>
              <ul className="delivery_timeline" data-avgper={getAvgVolumePer} style={{ "--bar-width": `${Math.round((628 * getAvgVolumePer)/100) + 110}px` }}>
                {isNewDay ? (
                  <li key="0">
                    <span
                      className="date"
                      style={{ color: todayChnPer > 0 ? "#649664" : "#c85050" }}
                    >
                      {moment(todayCurrentTime).format("HH:mm A")}
                    </span>
                    <span
                      className={`percentBar ${
                        todayVolume > getAvgVolume &&
                        getAvgVolume > NSE_filter_volume
                          ? "avgvolumeTrue"
                          : ""
                      }`}
                      style={{
                        width: `${todayPercent}%`,
                        background:
                          todayVolume > max && todayPrevDiff > 125
                            ? "#ffc800"
                            : todayVolume > max
                            ? "#15d915"
                            : "#E6E6E6",
                      }}
                    >
                      <span className="volume">
                        <span>{todayVolume.toLocaleString("en-IN")}</span> [
                        {todayPrevDiff}%]
                      </span>
                      {/* <span className="delvPer">{item.delivery_per}%</span> */}
                    </span>
                    <span className="momentum">{getMomentumData.momentum_type}</span>
                    <span
                      className="price"
                      style={{ color: todayChnPer > 0 ? "#649664" : "#c85050" }}
                      title={`${todayLTP?.LOW}(L) | ${todayLTP?.OPEN}(O) — ${todayLTP?.HIGH}(H)`}
                    >
                      {todayLTP?.LTP !== "#N/A" ? todayLTP?.LTP?.toFixed(2) : 0.0}{" "}
                      [{Math.abs(todayChnPer).toFixed(2)}%]
                    </span>
                    <span className="score">{getDeliverData[0]?.score}</span>
                    <span className="atr">{getDeliverData[0]?.ATR_PER}</span>
                    <span
                      className="marketcap"
                      style={{
                        background: todayTurnover_per >= 5 ? "#ffc800" : "",
                      }}
                    >
                      {todayTurnover_Cap} [{todayTurnover_per}%]
                    </span>
                  </li>
                ) : null}
                {getDeliverData
                  ?.slice(0, getDeliverData.length - 1)
                  .map((item, index) => {
                    // console.log(item);
                    const volume = parseInt(item.ttl_trd_qty);
                    const delivery_qty = parseInt(item.delivery_qty);
                    const prev_volume = parseInt(getDeliverData[index + 1].ttl_trd_qty);
                    const MarketCap = parseInt(item.MARKETCAP * 10000000);
                    const ratio = (volume - min) / (max - min);
                    let datepercent = Math.round(minPct + ratio * (maxPct - minPct));
                    let prevDiff = (((volume - prev_volume) * 100) / prev_volume).toFixed("2");

                    let LTP = parseFloat(item.close_price);

                    let Turnover = volume * LTP;
                    let Turnover_Cap = Math.round(Turnover / 10000000);
                    let Turnover_per = Math.abs(((Turnover / MarketCap) * 100).toFixed(2));

                    let Turnover_Del = delivery_qty * LTP;
                    let Turnover_Del_Cap = Math.round(Turnover_Del / 10000000);
                    let Turnover_Del_per = Math.abs(((Turnover_Del / MarketCap) * 100).toFixed(2));

                    let smentery = false;
                    let tradeSpike =  false;

                    // console.log(">>>", item)
                    if(parseInt(item.no_of_trades) < getAvgNoTrde && volume > getAvgVolume){
                      tradeSpike = true;
                    }
                    let tradesDiff = 40 +  ((parseInt(item.no_of_trades) - getAvgNoTrde) / getAvgNoTrde) * 100;
                  
                    return (
                      <li key={index + 1}>
                        <span
                          className={`date ${
                            moment(date).format("YYYY-MM-DD") ===
                            moment(item.delivery_date).format("YYYY-MM-DD")
                              ? "indicator"
                              : ""
                          }`}
                          style={{
                            color: Number(item.chn_per) > 0 ? "#649664" : "#c85050",
                          }}
                          title="Date & Rank"
                        >
                          {moment(item.delivery_date).format("Do MMM")} [
                          {item.rank}]
                        </span>
                        <span
                          className={`percentBar ${
                            volume > getAvgVolume 
                            && getAvgVolume > NSE_filter_volume
                              ? "avgvolumeTrue"
                              : ""
                          }`}
                          style={{
                            width: `${datepercent}%`,
                            background:
                              index === 0 && volume >= max && prevDiff > 125
                                ? "#ffc800"
                                : volume === max
                                ? "#0F0"
                                : volume === min
                                ? "#F00"
                                : "#E6E6E6",
                          }}
                        >
                          <span className="volume">
                            <span>{volume.toLocaleString("en-IN")} {tradeSpike === true? <i className="smentry"></i> : ''}</span> [
                            {prevDiff}%] 
                          </span>
                          <span className="delvPer">{item.delivery_per}%</span>
                          <span
                            className="delvPerBar"
                            style={{ width: item.delivery_per + "%" }}
                          ></span>
                          <span className="trades_no_per" title={(tradesDiff - 40).toFixed(2)}
                            style={{width: tradesDiff < 0 ? `${Math.abs(tradesDiff)}%` : "0%"}}
                          ></span>
                        </span>
                        {parseInt(item.SMEntery) === 1 ? (
                          <span className="smentry" title="SME Entery"></span>
                        ) : (
                          ""
                        )}

                        {parseInt(item.volume_spike) === 1 ? (
                          <span className="volumespike" title="Volume Spike"></span>
                        ) : (
                          ""
                        )}
                        <span className="momentum">{item.momentum_type}</span>
                        <span
                          className={`price ${item.FVG === "BULLISH"? "fvgg": item.FVG === "BEARISH"? "fvgr" : "fff"}`}
                          style={{
                            color: item.chn_per > 0 ? "#649664" : "#c85050",
                            fontWeight: parseFloat(item.close_price) === parseFloat(maxClosePrice) || parseFloat(item.close_price) === parseFloat(minClosePrice)? "700": ""
                          }}
                          title={`L: ${item.low_price} | O: ${item.open_price} | H: ${item.high_price} ${ item.FVG_Body > 0 ? ` | F [${item.FVG_Body}%]` : ''}` }
                        >
                          {item.close_price} [{Math.abs(item.chn_per).toFixed(2)}
                          %]
                        </span>
                        <span className={`score ${parseInt(item.current_star) === 1 ? 'current_star' : ''}`}>{item.score}</span>
                        <span className="atr">{item.ATR_PER}</span>
                        <span
                          className="marketcap"
                          style={{
                            background:
                              MarketCap > 0 && Turnover_per >= 5 ? "#ffc800" : "",
                          }}
                        >
                          {Turnover_Cap}{" "}
                          {MarketCap > 0 ? `[${Turnover_per}%]` : ""}
                        </span>
                      </li>
                    );
                  })}
              </ul>


              <div className="priceChartWrapper">
                    <svg
                      id="priceChart"
                      className="priceChart"
                    >
                      {/* PRICE LINE */}
                      <polyline
                        points={dataRange.price}
                        fill="none"
                        stroke="#2b6cff"
                        strokeWidth="2"
                        transform="translate(0, -6)"
                      />

                      <polyline
                        points={dataRange.SMA20}
                        fill="none"
                        stroke="#fb9696"
                        strokeWidth="2"
                        transform="translate(0, -6)"
                      />

                      <polyline
                        points={dataRange.EMA20}
                        fill="none"
                        stroke="#71e571"
                        strokeWidth="2"
                        transform="translate(0, -6)"
                      />

                      {/* X-AXIS LINE */}
                      <line
                        x1={8}
                        y1={440}
                        x2={650}
                        y2={440}
                        stroke="#999"
                      />

                      {/* DATE TICKS */}
                      {xTicks.map((t, i) => (
                        <g key={i}>
                          <line
                            x1={t.x}
                            y1={440}
                            x2={t.x}
                            y2={450}
                            stroke="#999"
                          />
                          <text
                            x={t.x}
                            y={460}
                            textAnchor="middle"
                            fontSize="11"
                            fill="#666"
                          >
                            {t.label}
                          </text>
                        </g>
                      ))}
                    </svg>
              </div>

                
            </div>
            
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  };
  export default DeliveryGraph;
